<template>
    <button
        v-if="showButton"
        dusk="SmartZoomButton"
        class="absolute right-4 z-10 w-[190px] cursor-pointer select-none rounded border border-theme-border bg-theme-bg text-theme-text shadow-md outline-none transition-[bottom] duration-200 ease-out hover:shadow-lg focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 max-[570px]:left-1/2 max-[570px]:right-auto max-[570px]:-translate-x-1/2"
        :style="{ bottom: uiHidden ? '35px' : `${ui.toolbar.offsetHeight + 15}px` }"
        :disabled="isOffline"
        :aria-label="smartZoomLabel"
        @click="toggleSmartZoom"
    >
        <div class="flex items-center py-2">
            <div class="px-2">
                <svg-icon icon="baseline-visibility-24px" width="22px" height="22px"></svg-icon>
            </div>
            <span class="px-1 text-sm">SMART ZOOM</span>
            <div class="px-3">
                <div class="relative flex h-[18px] w-[18px] items-center justify-center">
                    <div class="absolute inset-0 scale-[1.2] rounded-full bg-blue-600 dark:bg-blue-500"></div>
                    <span dusk="SmartZoomButtonCount" class="z-10 text-xs font-medium text-white">
                        {{ articles?.length ?? 0 }}
                    </span>
                </div>
            </div>
        </div>
    </button>
</template>

<script>
'use strict';

import { mapGetters, mapMutations, mapState } from 'vuex';

export default {
    props: {
        articles: {
            type: Array,
            required: true,
        },
    },
    computed: {
        ...mapState([
            'uiHidden',
            'currentPageArticles',
            'sharedArticle',
            'ui',
            'device',
            'isOffline',
            'localizations',
            'lang',
        ]),
        ...mapGetters(['onlyMobileVisible']),
        showButton() {
            // Don't show button if there are no articles
            const hasArticles = this.articles?.length > 0;
            if (!hasArticles) {
                return false;
            }

            if (!this.onlyMobileVisible) {
                return true;
            }
            return !this.ui?.rightSubmenu?.opened;
        },
        smartZoomLabel() {
            const count = this.articles?.length ?? 0;
            const label = this.localizations?.[this.lang]?.tooltips?.smartZoom;
            return `${label} (${count})`;
        },
    },
    created() {
        if (this.sharedArticle?.id && !this.sharedArticle?.showed) {
            this.toggleSmartZoom();
        }
    },
    methods: {
        ...mapMutations(['toggleSmartZoom', 'setCurrentArticleIndex', 'setSharedArticle']),
    },
};
</script>
